module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-calendar/master-calendar-form/master-calendar-form.component.css
// module id = ./src/app/master/master-calendar/master-calendar-form/master-calendar-form.component.css
// module chunks = main